import Navbar from "components/HeaderListe/Navbar";
import React from "react";
import BreadCrumb from "components/RelationClientDetail/BreadCrumb";
import { DivBreadCrumb } from "components/RelationClientDetail/InfoClient/InfoClientCSS";
import { Outlet } from "react-router-dom";

const RelationClient = () => {
  const breadcrumbLinks = [
    { text: "Accueil", url: "#" }
  ]

  return (
    <div className="d-flex flex-column">
      <Navbar />
      <div style={{ marginBottom: "50px" }}>
        <DivBreadCrumb style={{ marginTop: "72px" }}>
          <BreadCrumb links={breadcrumbLinks} />
        </DivBreadCrumb>
      </div>
      <Outlet />
    </div>
  );
};

export default RelationClient;
